import { LogoMark } from "./Logo";
import { useLang } from "../../lib/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = t("marquee");
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="relative border-y hairline bg-[#05130f] py-7 overflow-hidden">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-display text-3xl sm:text-5xl tracking-tight ${i % 2 ? "font-serif-i text-[var(--husk)]" : "font-semibold text-[var(--cream)]"}`}>{t}</span>
            <LogoMark className="h-8 w-6 opacity-80" />
          </span>
        ))}
      </div>
    </div>
  );
};
